import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import './header.scss';

export const Header = ({ t }) => (
    <div className="header">
        <h1>{t('header.title')}</h1>
        <h2>{t('header.subtitle')}</h2>
        <h3>{t('header.directions')}</h3>
    </div>
);

Header.propTypes = {
    t: PropTypes.func.isRequired,
};

export default translate()(Header);
